module.exports = __webpack_public_path__ + "media/icons/inne_uslugi@2x-2569a71c.png";